/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*--------------------------------------------
  Back to top button
 --------------------------------------------*/
// Some windows function to call outside the file
window.myWindow = {
  SuccessAddToCart: function() {
    window.myCustomData = [];
    window.customDesignData = [];
    window.myPettimeasureData = [];
    $('#measurement-popup-petti').find("input[type='text']").val('');
    $('#measurement-popup-petti').find("input[type='email']").val('');
    $('#measurement-popup').find("input[type='radio']").prop('checked', false);
    $('#measurement-popup').find("input[type='text']").val('');
    $('#measurement-popup').find("input[type='email']").val('');
    $('#blouse-design').find("input[type='radio']").prop('checked', false);
    $('#blouse-design').find("input[type='text']").val('');
    $('#blouse-design').find("textarea").val('');
    $('#fallpico').prop('checked', false);
    $('#petticoat').prop('checked', false);
    $('#bdesign').prop('checked', false);
  }
}



$(document).ready(function() {
  var initBackToTop = function() {
    var backToTopElement = $('.BackTop'),
        backToTopOffset = 300,
        backToTopDuration = 500;
    $(window).on('scroll.backToTop', function() {
      if ($(this).scrollTop() > backToTopOffset) {
        backToTopElement.addClass('BackTop--Active');
      } else {
        backToTopElement.removeClass('BackTop--Active');
      }
    });
    backToTopElement.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, backToTopDuration);
      return false;
    });
  };
  initBackToTop();
});


//add to cart measurement data
$(document).ready(function(){
  window.customDesignData = [];
  window.customCut = null;
  window.petticoat = null;
  window.fallpico = null;
  window.myCustomData = [];
  window.myPettimeasureData = [];
  var AjaxAddToCartpetticoat = {
    init: function() {
      $('#measurement-popup-petti').on('submit', function(e){
        e.preventDefault();
          var pettimsrName = $("#pettilength").attr("data-name");
          var a = {};
		  var b = pettimsrName;
          a[b] = $("#pettilength").val();
          window.myPettimeasureData.push(a);
          
          var pettimsrName2 = $("#aroundwst").attr("data-name");
          var a2 = {};
		  var b2 = pettimsrName;
          a2[b2] = $("#aroundwst").val();
          window.myPettimeasureData.push(a2);
          
          var pettimsrName3 = $("#aroundhip").attr("data-name");
          var a3 = {};
		  var b3 = pettimsrName;
          a3[b3] = $("#aroundhip").val();
          window.myPettimeasureData.push(a3);
          
          var pettimsrName4 = $("#height").attr("data-name");
          var a4 = {};
		  var b4 = pettimsrName;
          a4[b4] = $("#height").val();
          window.myPettimeasureData.push(a4);
       
        $.magnificPopup.close();
        $('.successmsg').show().delay(5000).fadeOut(1000);
        });
    }
  }
  var AjaxAddToCartmsr = {
    init: function() {
      $('#measurement-popup').on('submit', function(e){
        e.preventDefault();
        $('#measurement-popup .custom-data').each(function (index) {
          if($(this).is(':checked')) {
            if($(this).val() === "Custom Size"){
              $('.custom-size tbody td').each(function(index){
                if($(this).attr('data-check') === "custom__data"){
                  var dataSize = $(this).find('input.custom-input').attr('data-size');
                  dataSize = 'Custom Size ' + dataSize;
                  
                  var d1 = {};
                  var d2 = dataSize;
                  d1[d2] = $(this).find('input.custom-input').val();                  
                  window.myCustomData.push(d1);
                }
              });
            }
            else {
              window.myCustomData.push({ "Blouse size": $(this).val() });
            }
          }
        });
        $.magnificPopup.close();
        $('.successmsg').show().delay(5000).fadeOut(1000);
      });
    }
  }


  var AjaxAddToCartdesign = {
    init: function() {

      $('#petticoat').on('click', function(){
        if($(this).prop("checked") == true){
          window.petticoat = $(this).val();
        }
        else {
          window.petticoat = null;
        }
      });
      $('#fallpico').on('click', function(){
        if($(this).prop("checked") == true){
          window.fallpico = $(this).val();
        }
        else {
          window.fallpico = null;
        }
      });

      $('#blouse-design').on('submit', function(e){
        e.preventDefault();
        $('#front input[type="radio"]').each(function(){
          if($(this).is(":checked")){
            var designName = $(this).attr("name");
            var d1 = {};
            var d2 = designName;
            d1[d2] = $(this).val();             
            window.customDesignData.push(d1);
          }

        });
        $('#back input[type="radio"]').each(function(){
          if($(this).is(":checked")){
            var designName = $(this).attr("name");
            var d1 = {};
            var d2 = designName;
            d1[d2] = $(this).val();             
            window.customDesignData.push(d1);
          }
        });
        $('#sleeve input[type="radio"]').each(function(){
          if($(this).is(":checked")){
            var designName = $(this).attr("name");
            var d1 = {};
            var d2 = designName;
            d1[d2] = $(this).val();             
            window.customDesignData.push(d1);
          }
        });
        $('#cut input[type="radio"]').each(function(){
          if($(this).is(":checked")){
            window.customCut = $(this).val();
          }
        });
        $('.opening input[type="radio"]').each(function(){
          if($(this).is(":checked")){
            var designName = $(this).attr("name");
            var d1 = {};
            var d2 = designName;
            d1[d2] = $(this).val();             
            window.customDesignData.push(d1);
          }
        });
        $('.padding input[type="radio"]').each(function(){
          if($(this).is(":checked")){
            var designName = $(this).attr("name");
            var d1 = {};
            var d2 = designName;
            d1[d2] = $(this).val();             
            window.customDesignData.push(d1);
          }
        });
        $('.piping input[type="radio"]').each(function(){
          if($(this).is(":checked")){
            var designName = $(this).attr("name");
            var d1 = {};
            var d2 = designName;
            d1[d2] = $(this).val();             
            window.customDesignData.push(d1);
          }
        });

        if( $("#requestfield").val() !== "" ) {
          var designName = $("#requestfield").attr("name");
          var d1 = {};
          var d2 = designName;
          d1[d2] = $("#requestfield").val();             
          window.customDesignData.push(d1);
        }  

        $.magnificPopup.close();
        $('#bdesign').prop('checked', true);
      });
    }
  }
  AjaxAddToCartpetticoat.init();
  AjaxAddToCartmsr.init();
  AjaxAddToCartdesign.init();
});



